import type { Address as ApiAddress } from '@portal/models/address';
import type { NoMultiLangCompanyCreateRequest } from '../suggestion-iterfaces';

export abstract class SuggestionsMapperService<Company, Address> {
  abstract mapCompany(data: Company): NoMultiLangCompanyCreateRequest | null;
  abstract mapAddress(data: Address): ApiAddress | null;
}
